import { atom } from 'recoil'

export enum TAB {
  BASIC = 'basic',
  MAP = 'map',
  LOG = 'log',
}

export const FormState = atom({
  key: 'valueChange',
  default: undefined,
})
